import { useContext } from 'react';
import { ServicesMaps, ServiceProviderContext } from '../MapReportingProvider';

export function useService<T>(serviceName: ServicesMaps) {
  const serviceProvider = useContext(ServiceProviderContext);
  return serviceProvider.resolve<T>(serviceName);
}